export const TEXT_MAX_LENGTH = {
  GSM_7: 160,
  NON_GSM: 70
};
